<div
  class="preview-icon-container"
  [class.updating]="isUpdating"
  [matTooltip]="tooltipText"
  matTooltipPosition="right"
  matTooltipClass="multiline-tooltip">
  @if (isUpdating) {
    <lib-cdw-spinner type="apple" size="small"></lib-cdw-spinner>
  } @else if (useMatIcon) {
    <mat-icon [style.color]="customTextColor">{{ isStale ? 'timelapse' : 'visibility' }}</mat-icon>
  } @else {
    <span class="material-icons-outlined" [style.color]="customTextColor">{{ isStale ? 'timelapse' : 'visibility' }}</span>
  }
</div>
